import fetch from '../../../utils/fetch'

export const toggleLike = (payload) => (
  fetch('/api/likes/toggle', {
    method: 'POST',
    body: JSON.stringify(payload)
  })
    .then((res) => res.json())
)
